'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Avatar = require('../../01.atoms/Avatar/Avatar.js');
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var Modal = require('../../02.molecules/Modal/Modal.js');
var Toast = require('../../02.molecules/Toast/Toast.js');
require('./_index.scss.js');

/*************
 * ClassNames
 *************/

var CLASSNAME = 'varta-image-upload',
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnCol = "".concat(CLASSNAME, "__col"),
    cnColLeft = "".concat(cnCol, "--left"),
    cnColRight = "".concat(cnCol, "--right"),
    cnInput = "".concat(CLASSNAME, "__input"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnDropZone = "".concat(CLASSNAME, "__drop-zone"),
    cnDropActive = "".concat(cnDropZone, "--active"),
    cnFileButton = "".concat(CLASSNAME, "__file-button"),
    cnFileButtonLabel = "".concat(cnFileButton, "__label"),
    cnFileButtonIcon = "".concat(cnFileButton, "__icon"),
    cnModal = "".concat(CLASSNAME, "__modal"),
    cnButtons = "".concat(CLASSNAME, "__buttons"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnImagePreviews = "".concat(CLASSNAME, "__image-previews"),
    cnImagePreviewsActive = "".concat(cnImagePreviews, "--active"),
    cnImagePreview = "".concat(CLASSNAME, "__image-preview"),
    cnImage = "".concat(CLASSNAME, "__image"),
    cnImageEmpty = "".concat(cnImage, "--empty"),
    cnImageIcon = "".concat(cnImage, "__icon"),
    cnBattery = "".concat(CLASSNAME, "__battery"),
    cnFileConditions = "".concat(CLASSNAME, "__file-conditions");
var MAX_SIZE = 5 * 1024 * 1024;
var MIME_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
/**
 * 
 */

var ImageUpload = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(ImageUpload, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(ImageUpload);

  function ImageUpload() {
    var _map, _ref;

    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, ImageUpload);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      fileURLs: _this.props.fileURLs || ((_map = (_ref = _this.props.files || []).map) === null || _map === void 0 ? void 0 : _map.call(_ref, function (a) {
        return URL.createObjectURL(a);
      })),
      files: _this.props.files || []
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "inputRef", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onBeforeEdit", function (e, cb, index) {
      e.persist();
      var onBeforeEdit = _this.props.onBeforeEdit;

      if (onBeforeEdit) {
        return onBeforeEdit(e, function () {
          return cb(e, true, index);
        });
      }

      return true;
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onClick", function (e, force) {
      var multiple = _this.props.multiple;

      if (!force && !_this.onBeforeEdit(e, _this.onClick)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      if (!_this.isTouchDevice && !multiple) {
        e.preventDefault();
        e.stopPropagation();

        _this.setState({
          open: true
        });
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onTouchStart", function () {
      _this.isTouchDevice = true;
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onModalClose", function () {
      _this.setState({
        open: false
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onDragOver", function (e) {
      var dragOver = _this.state.dragOver;
      e.stopPropagation();
      e.preventDefault();

      if (!dragOver) {
        _this.setState({
          dragOver: true
        });
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onDragLeave", function () {
      _this.setState({
        dragOver: false
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onDrop", function (e) {
      e.preventDefault();
      var files = e.dataTransfer.items ? _rollupPluginBabelHelpers.toConsumableArray(e.dataTransfer.items).filter(function (a) {
        return a.kind === 'file';
      }).map(function (a) {
        return a.getAsFile();
      }) : _rollupPluginBabelHelpers.toConsumableArray(e.dataTransfer.files);

      _this.onFiles(files.filter(function (a) {
        return a.size <= MAX_SIZE;
      }).filter(function (a) {
        return MIME_TYPES.indexOf(a.type) > -1;
      }));
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onInputChange", function (e) {
      var files = _rollupPluginBabelHelpers.toConsumableArray(e.target.files).filter(function (a) {
        return a.size <= MAX_SIZE;
      });

      _this.onFiles(files);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onDelete", function (e, force, index) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props = _this.props,
          onFile = _this$props.onFile,
          onRemoveFile = _this$props.onRemoveFile;

      if (!force && !_this.onBeforeEdit(e, _this.onDelete, index)) {
        return;
      }

      _this.setState(function (state) {
        var fileURLs = state.fileURLs,
            files = state.files;

        if (typeof index === 'number') {
          fileURLs.splice(index, 1);
          files.splice(index, 1);
        } else {
          fileURLs = [];
          files = [];
        }

        onFile(files);
        return {
          fileURLs: _rollupPluginBabelHelpers.toConsumableArray(fileURLs),
          files: _rollupPluginBabelHelpers.toConsumableArray(files),
          open: false,
          dragOver: false
        };
      });

      onRemoveFile(e, index);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "hideToast", function () {
      _this.setState({
        showToast: false
      });
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(ImageUpload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.value;

      if (value) {
        this.onFiles([value]);
      }
    }
  }, {
    key: "onFiles",
    value:
    /**
     * Writes file and its object url into the state
     *
     * @param {Array<File>} fileList - List of files. Only first file is processed
     */
    function onFiles(files) {
      var _this$props2 = this.props,
          onError = _this$props2.onError,
          multiple = _this$props2.multiple;

      if (!files.length) {
        // TODO get error type
        onError();
        console.log('wrong size or file type');
        this.setState({
          dragOver: false,
          open: false // showToast: true

        });
        return;
      }

      if (multiple && files.length > multiple) {
        files.length = multiple;
      }

      var onFile = this.props.onFile;
      var fileURLs = files.map(function (a) {
        return URL.createObjectURL(a);
      });
      this.setState(function (state) {
        fileURLs = [].concat(_rollupPluginBabelHelpers.toConsumableArray(state.fileURLs), _rollupPluginBabelHelpers.toConsumableArray(fileURLs));
        files = [].concat(_rollupPluginBabelHelpers.toConsumableArray(state.files), _rollupPluginBabelHelpers.toConsumableArray(files));

        if (multiple && files.length > multiple) {
          files.length = multiple;
          fileURLs.length = multiple;
        }

        if (multiple) {
          onFile(files, fileURLs);
        } else {
          onFile(files[0], fileURLs[0]);
        }

        return {
          fileURLs: fileURLs,
          files: files,
          open: false,
          dragOver: false
        };
      });
    }
  }, {
    key: "renderImagePreview",
    value: function renderImagePreview() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          _this$props3$profile = _this$props3.profile,
          image = _this$props3$profile.image,
          color = _this$props3$profile.color,
          iconId = _this$props3.iconId,
          i18n = _this$props3.i18n,
          multiple = _this$props3.multiple;
      var _this$state = this.state,
          open = _this$state.open,
          dragOver = _this$state.dragOver,
          fileURLs = _this$state.fileURLs,
          showToast = _this$state.showToast;

      if (!multiple) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
          className: classNames(cnCol, cnColLeft)
        }, /*#__PURE__*/React__default.createElement(Avatar, {
          image: fileURLs[0] || image,
          color: color,
          size: "lg"
        })), /*#__PURE__*/React__default.createElement("div", {
          className: classNames(cnCol, cnColRight)
        }, image || fileURLs[0] ? /*#__PURE__*/React__default.createElement("div", {
          className: cnButtons
        }, /*#__PURE__*/React__default.createElement(ButtonLink, {
          iconLeft: "edit",
          tagName: "span",
          link: null,
          title: i18n.editImage,
          className: cnButton
        }), /*#__PURE__*/React__default.createElement(ButtonLink, {
          onClick: this.onDelete,
          iconLeft: "times",
          title: i18n.deleteImage,
          className: cnButton
        })) : [/*#__PURE__*/React__default.createElement("div", {
          className: cnButtons,
          key: "1"
        }, /*#__PURE__*/React__default.createElement(ButtonPlain, {
          title: i18n.uploadImage,
          className: cnButton,
          tagName: "div"
        })), /*#__PURE__*/React__default.createElement("i", {
          key: "2"
        }, i18n.fileConditions)]));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnImagePreviews, _rollupPluginBabelHelpers.defineProperty({}, cnImagePreviewsActive, dragOver)),
        onDragOver: this.onDragOver,
        onDragLeave: this.onDragLeave,
        onDrop: this.onDrop
      }, _rollupPluginBabelHelpers.toConsumableArray(new Array(multiple)).map(function (a, i) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: cnImagePreview,
          key: fileURLs[i] || i
        }, /*#__PURE__*/React__default.createElement("div", {
          className: classNames(cnImage, _rollupPluginBabelHelpers.defineProperty({}, cnImageEmpty, !fileURLs[i])),
          style: {
            backgroundImage: fileURLs[i] ? "url(".concat(fileURLs[i], ")") : ''
          }
        }, !fileURLs[i] && /*#__PURE__*/React__default.createElement("div", {
          className: cnBattery
        }), fileURLs[i] && /*#__PURE__*/React__default.createElement("div", {
          className: cnImageIcon,
          onClick: function onClick(e) {
            return _this2.onDelete(e, true, i);
          }
        }, /*#__PURE__*/React__default.createElement(Icon, {
          id: "times-small",
          size: "sm"
        }))));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          image = _this$props4.profile.image,
          iconId = _this$props4.iconId,
          i18n = _this$props4.i18n,
          multiple = _this$props4.multiple,
          name = _this$props4.name;
      var _this$state2 = this.state,
          open = _this$state2.open,
          dragOver = _this$state2.dragOver,
          fileURLs = _this$state2.fileURLs,
          showToast = _this$state2.showToast;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(className, CLASSNAME)
      }, /*#__PURE__*/React__default.createElement("label", {
        className: classNames(cnLabel),
        onClick: this.onClick,
        onTouchStart: this.onTouchStart
      }, this.renderImagePreview(), /*#__PURE__*/React__default.createElement("input", {
        onChange: this.onInputChange,
        className: cnInput,
        type: "file",
        accept: ".jpg, .jpeg, .png, ".concat(MIME_TYPES.join(', '), ", capture=camera"),
        multiple: !!multiple,
        name: name,
        ref: this.inputRef
      }), /*#__PURE__*/React__default.createElement(Modal, {
        open: open,
        onClose: this.onModalClose,
        title: image || fileURLs[0] ? i18n.editImage : i18n.uploadImage,
        showCloseButton: true,
        className: cnModal,
        noPadding: true
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnDropZone, _rollupPluginBabelHelpers.defineProperty({}, cnDropActive, dragOver)),
        onDragOver: this.onDragOver,
        onDragLeave: this.onDragLeave,
        onDrop: this.onDrop
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: iconId,
        size: "xl",
        className: cnIcon
      }), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("b", null, i18n.dragAndDropFile)), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("i", null, i18n.fileConditions)), /*#__PURE__*/React__default.createElement("label", {
        className: cnFileButton
      }, /*#__PURE__*/React__default.createElement("span", {
        className: cnFileButtonLabel
      }, i18n.selectFile), /*#__PURE__*/React__default.createElement("input", {
        onChange: this.onInputChange,
        className: cnInput,
        type: "file",
        accept: ".jpg, .jpeg, .png, ".concat(MIME_TYPES.join(', '), ", capture=camera"),
        multiple: !!multiple
      }), /*#__PURE__*/React__default.createElement(Icon, {
        id: "caret-down",
        className: cnFileButtonIcon,
        size: "sm"
      })))), /*#__PURE__*/React__default.createElement(Toast, {
        title: i18n.errorTitle,
        subline: i18n.errorBody,
        button: {
          title: i18n.errorButtonTitle,
          onClick: function onClick() {
            return void 0;
          }
        },
        open: showToast,
        onClose: this.hideToast
      })), !!multiple && /*#__PURE__*/React__default.createElement("i", {
        className: cnFileConditions
      }, i18n.fileConditions));
    }
  }]);

  return ImageUpload;
}(React__default.Component);
Image.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  profile: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    image: PropTypes.string,
    color: PropTypes.string
  }),
  onFile: PropTypes.func,
  onRemoveFile: PropTypes.func,
  onError: PropTypes.func,
  onBeforeEdit: PropTypes.func,
  value: PropTypes.any,
  iconId: PropTypes.string,
  multiple: PropTypes.number,
  files: PropTypes.array,
  i18n: PropTypes.shape({
    editImage: PropTypes.string.isRequired,
    deleteImage: PropTypes.string.isRequired,
    uploadImage: PropTypes.string.isRequired,
    dragAndDropFile: PropTypes.string.isRequired,
    errorTitle: PropTypes.string.isRequired,
    errorBody: PropTypes.string.isRequired,
    errorButtonTitle: PropTypes.string.isRequired,
    selectFile: PropTypes.string.isRequired,
    fileConditions: PropTypes.string
  }).isRequired
};
Image.defaultProps = {
  profile: {},
  onFile: function onFile() {
    return void 0;
  },
  onError: function onError() {
    return void 0;
  },
  iconId: 'upload-image',
  i18n: {}
};

module.exports = ImageUpload;
